/// <amd-module name="WidgetCommon/WorkItemResultsGrid/WorkItemResultsGridSettings" />
import { IVssPageContext } from "VSS/Platform/Context";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";

/* Encapsulate state and behavior for the user preferences stored in and retrieved from the platform settings service*/
export class WorkItemResultsGridUserSettings {
    public static async save(pageContext: IVssPageContext, widgetId: string, columnSettings: { [key: string]: number }): Promise<void> {
        const settingsService = pageContext.getService<ISettingsService>("ISettingsService");

        const userColumnSettings: {
            [key: string]: any;
        } = {};
        for (const column in columnSettings) {
            if (columnSettings.hasOwnProperty(column)) {
                const width = columnSettings[column];
                userColumnSettings[`${widgetId}/${column}`] = width;
            }
        }
        await settingsService.setEntries(userColumnSettings, SettingsUserScope.Me);
    }

    public static async load(pageContext: IVssPageContext, widgetId: string): Promise<{ [key: string]: number }> {
        const settingsService = pageContext.getService<ISettingsService>("ISettingsService");

        return settingsService.getEntriesAsync(widgetId, SettingsUserScope.Me);
    }
}
